export default __webpack_public_path__ + "static/media/image2historia.7b4515f8.jpeg";